export const alertConstants = {
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
    CONFIRM: 'ALERT_CONFIRM',
    CONFIRM2: 'ALERT_CONFIRM2',
    INFO: 'ALERT_INFO'
}
